<template>
  <div
    v-if="userId"
    class="section content"
  >
    <div class="columns">
      <div class="column has-text-centered">
        <h2 class="title is-2">
          Password Reset Link
        </h2>
        <div class="subtitle is-2">
          Generate a "password reset" link you can send to this user.
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full has-text-centered">
        <button
          class="button is-secondary"
          :class="isGen ? 'is-loading' : ''"
          type="button"
          @click="generateLink"
        >
          Generate Link
        </button>
      </div>
      <div
        v-if="link"
        class="column is-full"
      >
        This is a <b>one time</b> link and it will expire in 60 minutes. Generating a new link will cause the previous link to be invalid.
        <pre>{{ link }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ResetPasswordLinkGen",
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      isGen: false,
      link: null,
    };
  },
  methods: {
    async generateLink () {
      this.isGen = true;
      let link = await this.$store.dispatch('user/genPasswordResetLink', this.userId);
      if (link) {
        this.link = link;
      }
      this.isGen = false;
    },
  },
};
</script>